<div #modal data-bs-backdrop="static" class="modal new-mca-modal fade" role="dialog" tabindex="-1" style="z-index: 10000">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <ng-template #container></ng-template>
  </div>
</div>
